import styled from 'styled-components'

const Queue = ({
  current,
  answers,
  total,
}: {
  current: number
  total: number
  answers: Answer[]
}) => {
  return (
    <QueueContainer>
      {[...answers, ...Array(total - answers.length)].map((a, i) => {
        return (
          <Dot
            style={{
              backgroundColor:
                a && a.correct
                  ? 'var(--correct-color)'
                  : a && !a.correct
                  ? 'var(--wrong-color)'
                  : current === i
                  ? 'var(--text-color)'
                  : 'var(--beige-bright-1',
            }}
          />
        )
      })}
    </QueueContainer>
  )
}
const QueueContainer = styled.div`
  display: flex;
  gap: 5px;
`

export default Queue

const Dot = styled.div`
  width: 7px;
  height: 7px;
  border-radius: 50%;
`
